import { SymHaken, SymLaedt } from "./symbole";

/**
 * Speicherstand des Editors. Der Baustein zeigt nur an; WANN und WIE gespeichert wird (Takt, Konflikt, die Action),
 * entscheidet die Seite (Paket P4), nicht der Editor-Baustein. Es wird nichts gemessen oder protokolliert (r260):
 * der Wortlaut kommt aus dem Zeitpunkt des letzten Speicherns, den die Seite ohnehin kennt.
 */
export type EditorSpeicherstand =
  | { art: "unbekannt" }
  | { art: "gespeichert"; text: string }
  | { art: "speichert" }
  | { art: "fehlgeschlagen" }
  /** Konflikt (P4-S Slice S9, O13, additiv): der Text wurde inzwischen anderswo geändert; den Hinweis trägt der Rahmen (`konflikt`). */
  | { art: "konflikt" };

/** Satz bei Fehlschlag (r105: über den Vorgang, wiederholbar, ohne Code). Eingaben bleiben im Editor erhalten. */
export const SPEICHERN_FEHLSCHLAG_SATZ = "Der Text konnte nicht gespeichert werden. Bitte erneut versuchen. Ihre Eingaben bleiben erhalten.";

/** „Gespeichert vor 1 Min“, „… vor 3 Std“, „… gerade eben“, „… vor 2 Tagen“ aus der vergangenen Zeit in Millisekunden. */
export function gespeichertText(vergangenMs: number): string {
  const min = Math.floor(Math.max(0, vergangenMs) / 60000);
  if (min < 1) return "Gespeichert gerade eben";
  if (min < 60) return `Gespeichert vor ${min} Min`;
  const std = Math.floor(min / 60);
  if (std < 24) return `Gespeichert vor ${std} Std`;
  const tage = Math.floor(std / 24);
  return tage === 1 ? "Gespeichert vor 1 Tag" : `Gespeichert vor ${tage} Tagen`;
}

const TEXT_KLASSE = "inline-flex items-center gap-x-1.5 text-xs text-muted-foreground-1";

/**
 * Anzeige des Stands (`aria-live="polite"`, damit „Speichert …“ und „Gespeichert“ vorgelesen werden, ohne zu unterbrechen).
 * Der Fehlschlag und der Konflikt stehen hier nicht als Satz: den trägt der Rahmen (Hinweissatz bzw. Konflikt-Hinweis mit
 * den zwei Knöpfen, r105); die Anzeige zeigt dann nur „Nicht gespeichert“.
 */
export function EditorSpeicherstandAnzeige({ stand }: { stand: EditorSpeicherstand }) {
  let inhalt: React.ReactNode = null;
  if (stand.art === "gespeichert") {
    inhalt = (
      <>
        <SymHaken />
        {stand.text}
      </>
    );
  } else if (stand.art === "speichert") {
    inhalt = (
      <>
        <span className="motion-safe:animate-spin">
          <SymLaedt />
        </span>
        Speichert …
      </>
    );
  } else if (stand.art === "fehlgeschlagen" || stand.art === "konflikt") {
    inhalt = "Nicht gespeichert";
  }
  return (
    <>
      {/* Preline: forms/forms-sub-core-inputs-layouts/forms-cat-text-editors/rich-text-editor-card */}
      <p className={TEXT_KLASSE} role="status" aria-live="polite">
        {inhalt}
      </p>
    </>
  );
}
